import { FC } from 'react'

import styled from 'styled-components'

import { colors, fontSizes } from 'src/Helpers/constants'

const Name = styled.span`
  font-size: ${fontSizes.medium};
  color: ${colors.thirdGray};
  font-weight: 600;
`

export const NoDataMessage: FC = () => {
  return <Name>Нет данных для отображения</Name>
}
